import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BrainstormPage } from './brainstorm';

@NgModule({
  declarations: [
    BrainstormPage,
  ],
  imports: [
    IonicPageModule.forChild(BrainstormPage),
  ],
})
export class BrainstormPageModule {}



// WEBPACK FOOTER //
// ./src/pages/brainstorm/brainstorm.module.ts